import axios from "axios";
import constants from "@/constants";
import { getAuth, onAuthStateChanged } from "firebase/auth";

class CategorySetters {
  static async createCategory(passedData) {
    return new Promise((resolve, reject) => {
      const auth = getAuth();
      const unsubscribe = onAuthStateChanged(auth, (user) => {
        if (user) {
          auth.currentUser
            .getIdToken(/* forceRefresh */ true)
            .then((idToken) => {
              const url = `${constants.apiUrl}/event-categories-setters/add-event-category`;

              const config = {
                headers: {
                  Accept: "application/json",
                  "Content-Type": "application/json;charset=UTF-8",
                  Authorization: `Bearer ${idToken}`,
                },
              };

              const data = passedData;

              axios
                .post(url, data, config)
                .then((data) => {
                  const response = data.data;
                  unsubscribe();
                  resolve(response);
                })
                .catch((err) => {
                  reject(err);
                });
            })
            .catch((err) => {
              reject(err);
            });
        }
      });
    });
  }

  static async updateCategory(categoryId, passedData) {
    return new Promise((resolve, reject) => {
      const auth = getAuth();
      const unsubscribe = onAuthStateChanged(auth, (user) => {
        if (user) {
          auth.currentUser
            .getIdToken(/* forceRefresh */ true)
            .then((idToken) => {
              const url = `${constants.apiUrl}/event-categories-setters/update-event-category/${categoryId}`;

              const config = {
                headers: {
                  Accept: "application/json",
                  "Content-Type": "application/json;charset=UTF-8",
                  Authorization: `Bearer ${idToken}`,
                },
              };

              const data = passedData;

              axios
                .put(url, data, config)
                .then((data) => {
                  const response = data.data;
                  unsubscribe();
                  resolve(response);
                })
                .catch((err) => {
                  reject(err);
                });
            })
            .catch((err) => {
              reject(err);
            });
        }
      });
    });
  }
  static async deleteCategory(categoryId) {
    return new Promise((resolve, reject) => {
      const auth = getAuth();
      const unsubscribe = onAuthStateChanged(auth, (user) => {
        if (user) {
          auth.currentUser
            .getIdToken(/* forceRefresh */ true)
            .then((idToken) => {
              const url = `${constants.apiUrl}/event-categories-setters/delete-event-category/${categoryId}`;

              const config = {
                headers: {
                  Accept: "application/json",
                  "Content-Type": "application/json;charset=UTF-8",
                  Authorization: `Bearer ${idToken}`,
                },
              };

              axios
                .delete(url, config)
                .then((data) => {
                  const response = data.data;
                  unsubscribe();
                  resolve(response);
                })
                .catch((err) => {
                  reject(err);
                });
            })
            .catch((err) => {
              reject(err);
            });
        }
      });
    });
  }
}

export default CategorySetters;
